<template>
    <div class="start-back">
        <div style="height:calc(0.23 * var(--body-height));"></div>
        <div style="text-align:center">
            <img src="@/assets/img/heart.png" class="heart-pic" alt="">
        </div>
        <div class="questionnaire-title">{{ $t('ema') }}</div>
        <div @click="checkRule" class="integral-rule">{{ $t('integralRule') }}>></div>
        <div class="btn-wrap">
            <el-button @click="toAnswer" :loading="btnLoading" class="orange-btn">{{ $t('startToAnswer') }}
            </el-button>
        </div>
    </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from "vuex";

export default {
    name: "index",
    data() {
        return {
            btnLoading: false
        }
    },
    computed: {
        ...mapGetters([
            'userId',
            'natureAnswerArr',
            'sliderAnswer',
            'mentalRadioAnswer'
        ]),
    },
    mounted() {
        // this.getLang();
        let this_ = this
        window.addEventListener("message",(ev)=>{
          if (ev.data.token) {
            const token = ev.data.token;
            const userId = ev.data.userId;
            this_.$store.commit("SET_USERTOKEN",token)
            this_.$store.commit("SET_ID",userId)
            //填写原本的mounted中执行的逻辑代码
            this_.getLang();
          }
        })
    },
    methods: {

        /**
         * 获取语言
         */
        getLang() {
            api.questionnaire.getUserDetail(this.userId).then(res => {
                let language = res.data.result.userDetailsInfo.language
                localStorage.setItem('userLang', language)
                this.$i18n.locale = language
            })
        },

        /**
         * 查看规则
         */
        checkRule() {
            this.$router.push('/rule')
        },

        /**
         * 去答题
         */
        toAnswer() {
            this.btnLoading = true
            let that = this
            api.questionnaire.isLessTen(this.userId).then(res => {
                let arr = res.data.result
                that.$store.commit('SET_AGGRESSION_FLAG', arr[2])
                // 是否展示任务评价 0-不展示；1-展示
                localStorage.setItem('showEvaluation', arr[4])
                //近14天内未答周问卷则不可答题
                if (arr[3] === 0) {
                    that.$toast({
                        message: that.$t('unansweredWeekly'),
                        duration: 2000
                    })
                    that.btnLoading = false
                    return;
                }
                if (arr[0] === 0) { //可答题
                    that.getUserLocate();
                } else if (arr[0] === 1) { //今天答题超过10次
                    that.$toast(this.$t('startTip'))
                    that.btnLoading = false
                } else { //答题间隔未超过三分钟
                    that.$toast(this.$t('startTip2'))
                    that.btnLoading = false
                }
            }).catch(err => {
                that.btnLoading = false
            })

        },

        /**
         * 获取用户定位并跳转页面
         */ 
        getUserLocate() {
            let that = this
            if ("geolocation" in navigator) {
                const options = {
                    enableHighAccuracy: true,
                    timeout: 10000,
                    maximumAge: 0
                }
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        that.$store.commit('SET_LAT', position.coords.latitude)
                        that.$store.commit('SET_LON', position.coords.longitude)
                    },
                    (error) => {
                        that.$toast(error.message);
                    },
                    options
                );
            } else {
                that.$toast("Geolocation is not supported by this browser.");
            }
            that.resetVuex();
            that.btnLoading = false
            that.toDiffPage()
        },

        /**
         * 根据用户近三个月是否确认过用户须知情况跳转到不同的页面
         */
        toDiffPage() {
            let that = this
            api.questionnaire.isCheckedNotice(this.userId).then(res => {
                let flag = res.data.result
                if (!flag) { //近三个月未确认过用户须知
                    this.$router.push('/notice')
                } else { //确认过用户须知则直接跳转到感受页面
                    that.$router.push('/mental/a')
                }
            })
        },

        /**
         * 重置vuex
         */
        resetVuex() {
            this.$store.commit('SET_LAT', 0)
            this.$store.commit('SET_LON', 0)

            this.$store.commit('SET_LOCATION1_ANSWER', '')
            this.$store.commit('SET_LOCATION2_ANSWER', ['', ''])
            this.$store.commit('SET_LOCATION3_ANSWER', ['', ''])
            this.$store.commit('SET_LOCATION4_ANSWER', [])

            this.$store.commit('SET_NATURE_ANSWER_ARR', [
                ['1', ''],
                ['1_1', ''],
                ['2', ''],
                ['2_1', ''],
                ['2_2', ''],
                ['3', '']
            ])
            this.$store.commit('SET_SLIDER_ANSWER', [
                [1, 0],
                [2, 0],
                [3, 0],
                [4, 0],
                [5, 0],
                [6, 0]
            ])
            this.$store.commit('SET_MENTAL_RADIO_ANSWER', [
                [1, ''],
                [2, ''],
                [3, ''],
                [4, ''],
                [5, ''],
                [6, ''],
                [7, ''],
            ])

            this.$store.commit('SET_BUILDING_ANSWER', '')
            this.$store.commit('SET_SHOP_ANSWER', '')
            this.$store.commit('SET_STREET_ANSWER', '')

            this.$store.commit('SET_CAMERA_SHOW', true)
            this.$store.commit('SET_PHOTO_FILE', null)
            this.$store.commit('SET_AUDIO_FILE', null)
            this.$store.commit('SET_AUDIO_URL', null)

            this.$store.commit('codeItem', [
                ['indoorOutdoorNow', ''], //location step1
                ['placeType', ''], //location step2 / location step3
                ['naturePlantLevel', ''], //nature1
                ['natureWaterLevel', ''], //nature2
                ['natureSoundAnimalLevel', ''], //nature3
                ['urbanBuildingLevel', ''], //urban_elements第一题
                ['urbanShopSignLevel', ''], //urban_elements第二题
                ['urbanStreetLevel', ''], //urban_elements第三题
                ['weather', ''], //aggression_weather
                ['temperature', ''],//aggression_weather
                ['companion', ''] //location step4
            ])
        }
    }
}
</script>

<style scoped lang="less">
.start-back {
    position: relative;
    width: 100%;
    height: 100%;
    background-image: url("../../assets/img/startBack.png");
    background-size: cover;
}

.heart-pic {
    height: calc(0.13 * var(--body-height));
}

.questionnaire-title {
    font-size: 28px;
    color: #FFFFFF;
    font-weight: bold;
    text-align: center;
    /*margin: 4.187vh 0 1.847vh;*/
    margin: calc(0.041 * var(--body-height)) 0 calc(0.018 * var(--body-height));

}

.integral-rule {
    font-size: 14px;
    color: #333333;
    text-align: center;
}

.btn-wrap {
    position: absolute;
    left: 0;
    bottom: calc(0.174 * var(--body-height));
    width: 100%;
    text-align: center;
}

.orange-btn {
    width: 200px;
    color: #fff;
    font-size: 16px;

    /*height: 35px;*/
    background: #F6B122;
    border: none;
    /*border-radius: 10px;*/
}
</style>
